module.exports = __webpack_public_path__ + "img/worker-robots-speed.76bfbcbb.png";